// Náhrada za react-helmet-async (verze 2.x nepodporuje React 19 a v buildu nic nenastavovala -> SEO stránky
// ztratily vlastní <title>, description a canonical). Stejné použití jako Helmet:
//   <Helmet><title>…</title><meta name="description" content="…" /><link rel="canonical" href="…" /></Helmet>
// Existující značky v <head> (výchozí z public/index.html) se PŘEPÍŠOU, chybějící se vytvoří – žádné duplicity.
// Pre-render (react-snap) uloží DOM i s upravenou hlavičkou.
import { Children, isValidElement, useEffect } from "react";

const textOf = (children) =>
  Children.toArray(children)
    .map((c) => (typeof c === "string" || typeof c === "number" ? String(c) : ""))
    .join("")
    .replace(/\s+/g, " ")
    .trim();

function upsert(selector, create, apply) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  apply(el);
}

function applyHead(children) {
  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;
    const { type, props } = child;
    if (type === "title") {
      document.title = textOf(props.children);
    } else if (type === "meta") {
      const key = props.name ? "name" : props.property ? "property" : null;
      if (!key) return;
      const value = props[key];
      upsert(
        `meta[${key}="${value}"]`,
        () => {
          const m = document.createElement("meta");
          m.setAttribute(key, value);
          return m;
        },
        (m) => m.setAttribute("content", props.content ?? "")
      );
    } else if (type === "link" && props.rel === "canonical") {
      upsert(
        'link[rel="canonical"]',
        () => {
          const l = document.createElement("link");
          l.setAttribute("rel", "canonical");
          return l;
        },
        (l) => l.setAttribute("href", props.href)
      );
    } else if (type === "script" && props.type === "application/ld+json") {
      upsert(
        'script[type="application/ld+json"][data-page-schema]',
        () => {
          const s = document.createElement("script");
          s.setAttribute("type", "application/ld+json");
          s.setAttribute("data-page-schema", "");
          return s;
        },
        (s) => {
          s.textContent = textOf(props.children);
        }
      );
    }
  });
}

export function Helmet({ children }) {
  // klíč závislosti: obsah značek, aby se hlavička změnila jen při změně SEO údajů
  const signature = JSON.stringify(
    Children.toArray(children).map((c) => (isValidElement(c) ? [c.type, c.props] : null))
  );
  useEffect(() => {
    applyHead(children);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);
  return null;
}

export function HelmetProvider({ children }) {
  return children;
}
